<script setup lang="ts">
import CompactValueTrigger from "@/components/ui/inputs/compact/CompactValueTrigger.vue";
import { ref } from "vue";

defineProps<{
  caption?: string;
  value?: string;
  error?: boolean;
  editable?: boolean;
}>();

const contentRef = ref<HTMLElement | null>(null);

const focusInput = () => {
  contentRef.value?.querySelector<HTMLElement>("textarea, input")?.focus();
};
</script>

<template>
  <v-menu
    :disabled="!editable"
    :close-on-content-click="false"
    location="bottom start"
    @after-enter="focusInput"
  >
    <template #activator="{ props: menuProps }">
      <compact-value-trigger
        v-bind="menuProps"
        multiline
        :caption="caption"
        :value="value"
        :placeholder="caption"
        :error="error"
        :editable="editable"
      />
    </template>

    <v-card
      color="surface"
      elevation="8"
      class="tw:!p-3 tw:!rounded-xl tw:border tw:border-on-surface/5 tw:w-[22rem] tw:max-w-[calc(100vw-2rem)]"
    >
      <div ref="contentRef">
        <slot />
      </div>
    </v-card>
  </v-menu>
</template>
